import {IAuditLog, IRouteDefinitionParams, ITableColumn} from "../../../index";
import {AbstractSearch, tpl} from "../AbstractSearch";
import {lm} from "../../../appContext";
import {getHash, getRouteDefinition} from "../../../constants/RouteDefinitions";
import {escapeHTML, getEadmRole, getOrganizationFromId} from "../../../util/misc";
import {Entity2RouteId} from "../../../constants/EntityTypes";

export const template = tpl

export class viewModel extends AbstractSearch<IAuditLog> {
    protected readonly TABLE: ITableColumn<IAuditLog>[] = [
        {key: 'Id'},
        {key: 'EntryType'},
        {
            key: 'ObjectId', label: 'object', getContent: (o: IAuditLog) => {
                return `<span>${this.markText('objectid', o.objectid)}</span>
                <br>
                <span>${this.getLinkToObject(o, 'name')}</span>`
            },
        },
        {
            key: 'attributetype', label: 'attribute', getContent: (o: IAuditLog) => {
                return `<span title="${lm.t('((attribute)) [((type|ac))]')}">${o.attributetype}</span>
                <br>
                <span class="fnt--monospace" title="${lm.t('((attribute)) [((name|ac))]')}">${o.attributename}</span>`
            }
        },
        {key: 'newvalue', label: 'newvalue', html: false},
        {key: 'oldvalue', label: 'oldvalue', html: false},
        {key: 'Registered', label: 'date'},
        {key: 'registeredby'},
        {key: 'comment', html: false},
        {key: 'CompanyId', label: 'organization', validator: () => this.allOrganizations()},
    ]

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.init()
    }

    private getLinkToObject(o: IAuditLog, key: keyof IAuditLog): string {
        if (key == 'objectid' && !o.objectid) {
            return ''
        }
        let text: string = escapeHTML(o[key])
        if (o.entrytype == 'Delete') {
            return text
        }
        const entity = o.attributetype;
        const routeId = Entity2RouteId[entity]
        if (!routeId) {
            return text
        }
        const def = getRouteDefinition(routeId)
        if (!def?.permissionLevel || getEadmRole(getOrganizationFromId(o.companyid)) < def.permissionLevel) {
            return text
        }
        let options: any
        switch (entity) {
            case "CompanySyncStepEntity":
                options = {companysyncstepid: o.objectid}
                text = `[${lm.t(def?.labelLong + '|ac')}]`
                break
            default:
                options = {id: o.objectid}
                text = text || `[${lm.t(def?.label + '|ac')}]`
                break
        }
        const hash = getHash(routeId, options, true, o.companyid)
        if (hash) {
            return `<a href="${hash}">${text}</a>`
        }
        return text
    }

}
